import React from 'react';
import { PaddedBox } from 'src/components/base/container';
import { CardHeader } from 'src/components/common/common/CardHeader';

import { RegisterCard } from './styledComponents';


const RegisterSuccessModal: React.FC = () => {


    return (
      <RegisterCard>
        <CardHeader>Account Created - Requires Verification</CardHeader>
        <PaddedBox>
          An email has been sent to the provided address. Please check your email to complete the account recovery
          process. Remember if you do not see the email in your INBOX check your spam or junk folder as some emails may
          be directed out of INBOX.
        </PaddedBox>
      </RegisterCard>
    );
}

export default RegisterSuccessModal;